import MultiRegister from './multi-register.vue'
export default MultiRegister